export const SLIDE_WIDTH = 232;
export const ADDITIONAL_OFFSET = 42;
export const VISIBLE_SLIDES_COUNT = 3;
